import { render, staticRenderFns } from "./MaskLayout.vue?vue&type=template&id=30cbb886&scoped=true&"
import script from "./MaskLayout.vue?vue&type=script&lang=js&"
export * from "./MaskLayout.vue?vue&type=script&lang=js&"
import style0 from "./MaskLayout.vue?vue&type=style&index=0&id=30cbb886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cbb886",
  null
  
)

export default component.exports